import { propsCallback } from "./blueprint";
export var createSimpleLifecycle = function createSimpleLifecycle(kind, _callback) {
  return {
    instanceCallbacks: [{
      kind: kind,
      callback: function callback(props) {
        return function () {
          return _callback(props);
        };
      }
    }]
  };
};
export var createComparingLifecycle = function createComparingLifecycle(kind, _callback2) {
  return {
    instanceCallbacks: function instanceCallbacks() {
      var prevProps;
      return [propsCallback(function (props) {
        if (prevProps === undefined) {
          prevProps = props;
        }

        return props;
      }), {
        kind: kind,
        callback: function callback(props) {
          return function () {
            var prevPropsTmp = prevProps;
            prevProps = props;

            var result = _callback2(prevPropsTmp, props);

            return result;
          };
        }
      }];
    }
  };
};